
import { AUTH_TOKEN } from "../../constants/storageKeys";


export function generateUUID() {
  const cryptoObj = window.crypto || window.msCrypto; // IE11 için uyumluluk
  const buffer = new Uint8Array(16);
  cryptoObj.getRandomValues(buffer);

  // RFC4122 uyumlu versiyon ve varyant ayarı
  buffer[6] = (buffer[6] & 0x0f) | 0x40; // versiyon 4
  buffer[8] = (buffer[8] & 0x3f) | 0x80; // varyant

  const hex = [...buffer].map(b => b.toString(16).padStart(2, '0')).join('');

  return `${hex.substr(0, 8)}-${hex.substr(8, 4)}-${hex.substr(12, 4)}-${hex.substr(16, 4)}-${hex.substr(20, 12)}`;
}

export const isAuthenticate = () => {

  var token = localStorage.getItem(AUTH_TOKEN);
  if (token && token.length > 0) {
    return true;
  }
  return false;
}
export const isLogoAppProject = () => {
  let pathName = window.location.href;
  if (pathName.indexOf("https://tahsilat.elogo.com.tr:444") != -1) {
    return true;
  } else {
    return false;
  }
}

export const isValidEmailAddress = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};
export function isValidPhoneNumber(input_str) {
  // var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
  const re = /^(\+|00)?\d{1,4}[-\s]?\d{1,4}[-\s]?\d{2,4}[-\s]?\d{2,4}$/gm;
  return re.test(input_str);
}



export function turkishtoEnglish(value) {
  return value
    .replace(/Ğ/g, 'g')
    .replace(/Ü/g, 'u')
    .replace(/Ş/g, 's')
    .replace(/I/g, 'i')
    .replace(/İ/g, 'i')
    .replace(/Ö/g, 'o')
    .replace(/Ç/g, 'c')
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ı/g, 'i')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c');
};